import { render, staticRenderFns } from "./new5.vue?vue&type=template&id=74cae5bb&scoped=true&"
import script from "./new5.vue?vue&type=script&lang=js&"
export * from "./new5.vue?vue&type=script&lang=js&"
import style0 from "./new5.vue?vue&type=style&index=0&id=74cae5bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cae5bb",
  null
  
)

export default component.exports